<app-loading [showText]="false" *ngIf="loading"></app-loading>
<mat-form-field [formGroup]="parentFormGroup" appearance="outline" [class.hidden]="loading" [style]="loading ? 'display: none;' : ''" [style.width]="'100%'">
    <div style="display: flex; align-items: baseline">
        <mat-select style="flex-grow: 1;" #matSelect
                    [formControlName]="parentFormControlName"
                    [placeholder]="placeHolderLabel"
                    [disabled]="disabled"
                    (focus)="focussed()">
            <mat-select-trigger>
                <ng-container *ngIf="getSelectedElement()" [ngTemplateOutlet]="template || defaultContentTpl" [ngTemplateOutletContext]="{element:getSelectedElement()}"></ng-container>
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search
                        [noEntriesFoundLabel]="noEntriesFoundLabel"
                        placeholderLabel="Filtrer..."
                        [formControl]="filterCtrl"
                ></ngx-mat-select-search>
            </mat-option>
            <ng-container *ngIf="(filteredElements | async) as elements">
                <span style="font-size: 0.7em" *ngIf="elements && elements.length === 0">{{noEntriesFoundLabel}}</span>
            </ng-container>

            <mat-option disabled="true" class="new-item" *ngIf="newItemModalOptions"
                        (click)="newItemSelected(newItemModalOptions)">
                    <span>
                        <mat-icon>add_circle_outline</mat-icon><span>{{createButtonLabel ? createButtonLabel : "Créer"}}</span>
                    </span>
            </mat-option>

            <mat-option *ngIf="noValueLabel" [value]="undefined">
                {{noValueLabel}}
            </mat-option>
            <mat-option *ngFor="let selectFilterElement of filteredElements | async"
                        [value]="selectFilterElement.value" [id]="selectFilterElement.id">
                <ng-container [ngTemplateOutlet]="template || defaultContentTpl" [ngTemplateOutletContext]="{element:selectFilterElement.element}"></ng-container>
            </mat-option>
        </mat-select>
        <app-button size="small" [withMargin]="false" [withPadding]="false" iconName="trash" (click)="eraseSelection()" *ngIf="eraseSelectionEnabled" style="flex-grow: 0;">
        </app-button>
    </div>
    <mat-error *ngFor="let errorKey of errorsKey()">
        {{extractErrorMessage(errorKey)}}
    </mat-error>
</mat-form-field>

<ng-template #defaultContentTpl let-element='element'>
    <div [innerHTML]="element | keepHtml"></div>
</ng-template>

